import { Dispatch, SetStateAction } from 'react';
import { Updater } from '@tanstack/react-table';

export const createTableStateChangeHandler =
    <T>(setter: Dispatch<SetStateAction<T>>) =>
    (updaterOrValue: Updater<any>) => {
        setter((prev: T) => (typeof updaterOrValue === 'function' ? updaterOrValue(prev) : updaterOrValue));
    };
